export default "__VITE_ASSET__B1xvb4Vb__"